import React, { useState } from 'react'
import Select, { components } from 'react-select'
import { connect } from 'react-redux'
import { t } from 'translations'
import { removeDiacritics } from 'services/Utilities'

// Returns a loading component as well as a function to toggle it
const useUserPicker = () => {
  const [selectedUser, setSelectedUser] = useState()

  const DropdownIndicator = props => (
    <components.DropdownIndicator {...props}>
      <i className="fas fa-chevron-down pointer-cursor"></i>
    </components.DropdownIndicator>
  )

  const ClearIndicator = props => (
    <components.ClearIndicator {...props}>
      <i className="fas fa-times pointer-cursor"></i>
    </components.ClearIndicator>
  )

  const UserPickerComponent = ({ autoFocus, users, ...props }) => {
    return (
      <Select
        value={selectedUser}
        isClearable
        isSearchable
        autoFocus={autoFocus}
        getOptionLabel={({ fullName, employeeNumber }) => `${fullName} (${employeeNumber})`}
        getOptionValue={obj => obj._id}
        options={users}
        onChange={value => setSelectedUser(value)}
        openMenuOnClick={false}
        filterOption={(option, searchText) => {
          if (!option.label) return false
          const labelTransformed = removeDiacritics(option.label.toLowerCase())
          const searchTextTransfmored = removeDiacritics(searchText.toLowerCase())
          return labelTransformed.includes(searchTextTransfmored)
        }}
        noOptionsMessage={() => t('components.hooks.NO_OPTION')}
        placeholder={
          <>
            <i className="fa fa-search mr-1" />
            {t('components.hooks.PLACEHOLDER')}
          </>
        }
        {...props}
        components={{ DropdownIndicator, ClearIndicator }}
      />
    )
  }

  return [
    connect(mapStateToProps, mapDispatchToProps)(UserPickerComponent),
    { set: user => setSelectedUser(user), get: () => (selectedUser ? selectedUser._id : null) }
  ]
}

const mapStateToProps = ({ resources }) => ({ usersById: resources.usersById, users: resources.users })
const mapDispatchToProps = () => ({})

export default useUserPicker
